<template>
  <div class="process-status-card">
    <div class="ps-header">
      <i class="el-icon-data-line"></i>
      <span class="ps-title">参展进度</span>
      <span class="ps-sub">实时跟踪您的参展全流程</span>
    </div>
    <div class="ps-body">
      <el-steps :active="activeIndex" align-center>
        <el-step
          v-for="(step, idx) in steps"
          :key="idx"
          :title="step.title"
          :status="step.status"
          :description="step.desc"
          @click.native="goto(idx)"
        ></el-step>
      </el-steps>
      <div class="ps-branches">
        <div class="ps-branch-title">其他事项</div>
        <div class="branch-list">
          <div
            class="branch-item"
            v-for="(b, i) in branches"
            :key="i"
            @click="gotoBranch(b.route)"
          >
            <span class="branch-name">{{ b.title }}</span>
            <span class="branch-arrow">进入 ›</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 展商流程进度卡：报名 → 选展位 → 合同签订 → 缴费 → 通知书
// 数据来源：/qyProcessStatus/getByQyid（后端从 token 取当前展商，单表点查）
// 状态变更由管理端发起（如主任审核通过），展商端无法预知，故每次进入都实时拉取，不使用本地缓存

export default {
  name: 'ProcessStatus',
  data() {
    return {
      loading: false,
      raw: null
    };
  },
  computed: {
    statusMap() {
      const r = this.raw || {};
      return {
        signup: r.signupStatus || '0',
        booth: r.boothStatus || '0',
        contract: r.contractStatus || '0',
        contractHtsjzt: r.contractHtsjzt || '0',
        pay: r.payStatus || '0',
        notice: r.noticeStatus || '0',
        bgt: r.bgtStatus || '0',
        hk: r.hkStatus || '0',
        yqfk: r.yqfkStatus || '0'
      };
    },
    steps() {
      const m = this.statusMap;
      return [
        this.buildStep('报名登记', m.signup),
        this.buildStep('选择展位', m.booth),
        this.buildContractStep(m.contract, m.contractHtsjzt),
        this.buildStep('缴费付款', m.pay, '待确认'),
        this.buildStep('参展确认书', m.notice)
      ];
    },
    activeIndex() {
      const m = this.statusMap;
      // 各步是否"已完成"；合同步在 htsjzt=05(已发送展商待签) 时汇总虽为2，但视为未完成（待下载签署）
      const done = [
        m.signup === '2',
        m.booth === '2',
        (m.contract === '2' && m.contractHtsjzt !== '05'),
        m.pay === '2',
        m.notice === '2'
      ];
      let idx = done.findIndex(function (v) { return !v; });
      if (idx === -1) idx = done.length - 1;
      return idx;
    },
    branches() {
      return [
        { title: '标改特', route: '/bootTypeChangeZS' },
        { title: '会刊填报', route: '/publicationZS' },
        { title: '参展商证', route: '/participants/participants_baseinfo' }
      ];
    }
  },
  mounted() {
    this.loadStatus();
  },
  activated() {
    this.loadStatus();
  },
  methods: {
    goto(idx) {
      // 步骤 → 对应展商端菜单路由
      const routes = [
        '/exhprediction',                    // 报名登记 → 展商信息维护及报名
        '/exhibitor/booth/select',           // 选择展位 → 展位选择
        '/contract/manage/ManageZS',          // 合同签订 → 展商合同管理（中文版）
        '/financial/paymentZS',              // 缴费付款 → 展商付款管理
        '/downloadingZS'                     // 参展通知书 → 报到资料下载
      ];
      const path = routes[idx];
      if (path) {
        this.$router.push(path);
      }
    },
    mapToStatus(val) {
      if (val === '2') return 'finish';      // 已完成（绿）
      if (val === '3') return 'error';        // 驳回（红）
      if (val === '1') return 'process';       // 进行中 / 待审核（蓝）
      return 'wait';                           // 未进行（灰）
    },
    mapToDesc(val) {
      if (val === '2') return '已完成';
      if (val === '3') return '已驳回，请重新提交';
      if (val === '1') return '进行中·待审核';
      return '未进行';
    },
    // 合同步专属构建：按原始 htsjzt 细分展商待办
    // - htsjzt=05(已发送展商)：汇总虽为已完成(2)，但展商尚未下载签署，显示蓝色"待下载签署"并引导点击
    // - htsjzt=06/08/09 等：真正完成，显示绿色"已完成"
    // - 其余(02/03/04/07 等)：进行中，显示"签订中"
    buildContractStep(val, htsjzt) {
      if (val === '0') {
        // 合同未生成：灰、未进行
        return { title: '合同签订', status: 'wait', desc: '未进行' };
      }
      // 已发送展商、待展商下载签署：以原始 htsjzt 为准，不论 contractStatus 为何值，均显示"待下载签署"
      if (htsjzt === '05') {
        return { title: '合同签订', status: 'process', desc: '待下载签署' };
      }
      if (val === '2') {
        return { title: '合同签订', status: 'finish', desc: '已完成' };
      }
      return { title: '合同签订', status: 'process', desc: '签订中' };
    },
    // inProgressDesc：可选，覆盖"进行中"文案（如合同步显示"签订中"）
    buildStep(title, val, inProgressDesc) {
      var desc = this.mapToDesc(val);
      if (val === '1' && inProgressDesc) {
        desc = inProgressDesc;
      }
      return { title: title, status: this.mapToStatus(val), desc: desc };
    },
    gotoBranch(route) {
      if (route) {
        this.$router.push(route);
      }
    },

    loadStatus() {
      var vm = this;
      vm.loading = true;
      vm.$axios.post('/qyProcessStatus/getByQyid', {}).then(function (res) {
        const data = res.data && res.data.result ? res.data.result : null;
        vm.raw = data;
      }).catch(function () {
        vm.raw = null;
      }).then(function () {
        vm.loading = false;
      });
    }
  }
};
</script>

<style scoped>
.process-status-card {
  background: #fff;
  border-radius: 14px;
  margin-bottom: 22px;
  box-shadow: 0 6px 20px rgba(64, 158, 255, 0.10);
  overflow: hidden;
}
.ps-header {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  background: linear-gradient(135deg, #409EFF, #66b1ff);
  color: #fff;
}
.ps-header .el-icon-data-line {
  font-size: 20px;
  margin-right: 8px;
}
.ps-title {
  font-size: 17px;
  font-weight: 600;
}
.ps-sub {
  margin-left: 12px;
  font-size: 12px;
  opacity: 0.85;
}
.ps-body {
  padding: 30px 24px 34px;
}
.process-status-card /deep/ .el-step {
  cursor: pointer;
  padding: 0 4px;
}
.process-status-card /deep/ .el-step:hover .el-step__title {
  color: #409EFF;
}
.process-status-card /deep/ .el-step__title {
  font-size: 15px;
  font-weight: 600;
}
.process-status-card /deep/ .el-step__description {
  font-size: 12px;
}
.process-status-card /deep/ .el-step__head.is-finish .el-step__icon {
  background-color: #67c23a;
  border-color: #67c23a;
}
.process-status-card /deep/ .el-step__head.is-finish .el-step__line {
  background-color: #409EFF;
}
.process-status-card /deep/ .el-step__head.is-process .el-step__icon {
  background-color: #409EFF;
  border-color: #409EFF;
}
.process-status-card /deep/ .el-step__head.is-process .el-step__icon-inner {
  color: #fff;
}
.process-status-card /deep/ .el-step__head.is-error .el-step__icon {
  background-color: #f56c6c;
  border-color: #f56c6c;
}
.process-status-card /deep/ .el-step__head.is-error .el-step__icon-inner {
  color: #fff;
}
.process-status-card /deep/ .el-step__head.is-wait .el-step__icon {
  background-color: #f4f4f5;
  border-color: #dcdfe6;
}
.process-status-card /deep/ .el-step__head.is-wait .el-step__icon-inner {
  color: #c0c4cc;
}
.ps-branches {
  margin-top: 26px;
  padding-top: 20px;
  border-top: 1px dashed #ebeef5;
}
.ps-branch-title {
  font-size: 14px;
  font-weight: 600;
  color: #606266;
  margin-bottom: 14px;
}
.branch-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.branch-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(33.333% - 8px);
  min-width: 180px;
  padding: 12px 16px;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  background: #fafafa;
  cursor: pointer;
  transition: all 0.2s;
}
.branch-item:hover {
  border-color: #409EFF;
  background: #ecf5ff;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.15);
}
.branch-name {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/home/ProcessStatus.vue